module.exports = __webpack_public_path__ + "static/media/sn_ab_bb.344e3da8.jpg";